// Hulk Wishlist Enhancer - Full Inline Version with Stock Fallback
(function () {
  if (!window) return;

  const productCache = {};

  // Fetch product JSON once per handle
  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];

    const p = fetch(`/products/${handle}.js`)
      .then(r => (r.ok ? r.json() : null))
      .catch(() => null);

    productCache[handle] = p;
    return p;
  }

  // Map inventory quantity or available flag to stock text & class
  function getStockInfo(qty, available) {
     console.log("qty=====>",qty,"\navailable", available);
    // Use qty if defined
    if (qty != null) {
      qty = Number(qty);
      if (isNaN(qty)) return { text: "", className: "" };
          if (available === true && qty <= 0) return { text: "Vorbestellen", className: "pre-order" };
          if (qty <= 0) return { text: "Ausverkauft", className: "out-of-stock" };
          if (qty <= 10) return { text: "Nur noch geringer Lagerbestand", className: "low-stock" };
      return { text: "Sofort verfügbar", className: "in-stock" };
    }

    // Fallback to available flag
    if (available === true) return { text: "Verfügbar", className: "in-stock" };
    if (available === false) return { text: "Ausverkauft", className: "out-of-stock" };

    return { text: "", className: "" };
  }

  // Format date nicely
  function formatDate(d) {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return d;
    return dt.toLocaleDateString(undefined, { year: "numeric", month: "numeric", day: "numeric" });
  }

  // Enhance a single wishlist card
  function enhanceCard(card) {
    if (!card || card.classList.contains("hulk-enhanced")) return;

    const handle = card.getAttribute("data-handle");
    const variantId = card.getAttribute("data-varid");
    if (!handle) return;

    const meta = window.productMetafields?.[handle];
    const content = card.querySelector(".wishlist__product-content");
    if (!content) return;

      function getInventoryQuantity(handle) {
    return fetch(`/products/${handle}?view=hulkapps-wishlist`)
      .then(response => response.json())
      .then(data => {
        // return first variant inventory_quantity
        return data.product.variants[0].inventory_quantity;
      });
  }


    fetchProduct(handle).then(product => {
      if (!product) return;

      let qty = null;
      if (variantId) {
        const variant = product.variants.find(v => String(v.id) === variantId);
        if (variant && variant.inventory_quantity != null) qty = variant.inventory_quantity;
        // console.log("variantId",variant);
      }
      if (qty === null) {
        // Sum all variant quantities if available
        const sumQty = product.variants.reduce((sum, v) => sum + (v.inventory_quantity != null ? v.inventory_quantity : 0), 0);
        if (sumQty > 0) qty = sumQty;
        //  console.log("sumQty",sumQty);
      }
     var stock;
   
      
      // const stock = getStockInfo(qty, available);
      getInventoryQuantity(handle).then(pro_inv => {
        const available = product.available; // fallback if qty missing
        const stock = getStockInfo(pro_inv, available);
           const metaRelease = meta?.release_date ? formatDate(meta.release_date) : null;

      if (metaRelease || stock.text) {
        const el = document.createElement("p");
        el.className = "wishlist-meta-inline";

        let text = "";
        if (metaRelease) text += `Releasedatum: ${metaRelease}`;
        if (metaRelease && stock.text) text += " • jetzt vorbestellbar!";
        if (!metaRelease) {
          if (stock.text) text += stock.text;
        }

        el.textContent = text;

        // Add stock class for styling
        if (stock.text) el.classList.add(stock.className);

        content.appendChild(el);
      }

        });
     
    });

    card.classList.add("hulk-enhanced");
  }

  // Enhance all wishlist cards
  function enhanceAll() {
    document.querySelectorAll(".wishlist-card").forEach(enhanceCard);
  }

  // Observe dynamic wishlist additions via AJAX
  function observeWishlist() {
    const container = document.querySelector(".wishlist-grid-view") || document.body;

    const observer = new MutationObserver(() => {
      enhanceAll();
    });

    observer.observe(container, { childList: true, subtree: true });

    // Initial run
    enhanceAll();
  }

  // Run on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeWishlist);
  } else {
    observeWishlist();
  }
})();
